import { Navigate, Route, Routes } from 'react-router-dom';
import { useApp } from './state/AppState';
import { useVisualViewport } from './hooks/useVisualViewport';
import { LoginScreen } from './screens/LoginScreen';
import { JoinScreen } from './screens/JoinScreen';
import { ResetPasswordScreen } from './screens/ResetPasswordScreen';
import { ChatScreen } from './screens/ChatScreen';

export function App() {
  const { session } = useApp();
  // Высота приложения должна следовать за видимой областью: иначе клавиатура
  // на телефоне выталкивает низ ленты за границу экрана
  useVisualViewport();

  return (
    <Routes>
      {/* Ссылка-приглашение доступна и без входа — это точка входа новичка */}
      <Route path="/join/:code" element={<JoinScreen />} />
      {/* Смена пароля тоже без входа: человек как раз войти и не может */}
      <Route path="/reset/:code" element={<ResetPasswordScreen />} />
      <Route path="/" element={session ? <ChatScreen /> : <LoginScreen />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
